enum AccountingSoftwareBillStatus {
  Unknown = 'Unknown',
  /** This is the first step at marking the bill for payment */
  PayBill = 'PayBill',
  /** Wait until we have a payment that's scheduled so we can proceed with other reconcilation parts */
  WaitForScheduledPayment = 'WaitForScheduledPayment',
  TransferFromClearingToBank = 'TransferFromClearingToBank',
  TransferFeeFromClearing = 'TransferFeeFromClearing',
  ForexTransferBetweenPlootoClearing = 'ForexTransferBetweenPlootoClearing',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Error = 'Error',
  UnreconciliationCompleted = 'UnreconciliationCompleted',
  ManuallyReconciled = 'ManuallyReconciled',
  ManuallyUnreconciled = 'ManuallyUnreconciled',
  UpdateFxRate = 'UpdateFxRate',
  PendingUnreconciliation = 'PendingUnreconciliation',
}

export default AccountingSoftwareBillStatus;
